import { render } from "./MfittBookingProcessing.vue?vue&type=template&id=3370dffe"
import script from "./MfittBookingProcessing.vue?vue&type=script&lang=js"
export * from "./MfittBookingProcessing.vue?vue&type=script&lang=js"
script.render = render

export default script